import React from 'react';
import './ITServices.css'; // You can use this to override global section styles
import './CardGrid.css';   // Custom card styles here
import { card1, card2, card3, card4 } from '../assets';

const ITServices = () => {
  const cards = [
    {
      image: card1,
      text: "Industry-Specific Customization",
    },
    {
      image: card2,
      text: "Flexible Pricing & Consultation",
    },
    {
      image: card3,
      text: "Certified NetSuite Experts",
    },
    {
      image: card4,
      text: "Dedicated Customer Support",
    },
  ];

  return (
    <section className="services-section py-5">
      <div className="container">
        {/* Title */}
        <div className="text-center mb-5">
          {/* <h6 className="text-gradient fw-bold mb-2">OUR SERVICES</h6> */}
          <h2 className="fw-bold display-6">Why Choose SpireNest?</h2>
          <p className="lead mt-3">
            Choosing the right NetSuite services is crucial for a successful ERP implementation and long-term success.
            At SpireNest, we bring cloud-based ERP solutions to scale operations.
          </p>
        </div>
        
        {/* Card Grid */}
        <div className="row g-4">
          {cards.map((card, index) => (
            <div className="col-12 col-sm-6 col-lg-3" key={index}>
              <div className="simple-card h-100 text-center shadow-sm p-3 rounded">
                <div className="image-container mb-3">
                  <img
                    src={card.image}
                    alt={`Card ${index + 1}`}
                    className="card-image"
                  />
                </div>
                <h5 className="fw-semibold">{card.text}</h5>
              </div>
            </div>
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center mt-5">
          <a href="/contact" className="btn btn-gradient btn-lg px-4">
            Get Started with NetSuite
          </a>
        </div>
      </div>
    </section>
  );
};

export default ITServices;